<template>
    

    <div class='card purshase-product-info mb-4'>
        
        <div  class='product-name  card-header pointer'>
            <div class="row">
                <div class="col-8">
                    <div class='index' v-if="index > 0"> {{ purshaseProduct.id }} </div>
                    <h6 class='name f6 mt-2 o-60'> {{purshaseProduct.name.replace(/^([^\/]*?)\/.*/,'$1')}} </h6> 
                    <h5 class='name f5'> {{purshaseProduct.name.replace(/^[^\/]*?\//,'')}} </h5> 
                    <hr />
                    <h5>
                       {{ infoTeam }}
                   <!-- <pre>    {{ purshaseProduct }} </pre> -->
                    </h5>
                </div>
                <div class="col-4 h-100 flex align-center">
                   
                    <div :class="'payment-status ' +paymentStatus" v-b-tooltip='paymentStatus'>
                        <icon  icon="money-bill-alt" />
                        <!-- <icon :class="paymentStatus" icon="money-bill-alt" />
                        <icon :class="paymentStatus" icon="money-bill-alt" /> -->
                    </div>
                
                </div>
            </div>
        </div>

        <router-link
            v-if="gpxState"
            :to="'/myregistrations/'+purshaseProduct.id+'/gpx'"
            :class="['gpx-cta', 'gpx-cta--'+gpxState]"
            @click.native.stop>
            <span class="gpx-cta-icon">{{ gpxState === 'send' ? '📍' : '✓' }}</span>
            <span class="gpx-cta-text">
                <strong v-if="gpxState === 'send'">Envie o Tracklog da sua corrida</strong>
                <strong v-else>Tracklog enviado · {{ gpxCount }} arquivo{{ gpxCount > 1 ? 's' : '' }}</strong>
                <small v-if="gpxState === 'send'">Janela de envio aberta — comprove seu percurso</small>
                <small v-else-if="gpxState === 'sent-open'">Toque para ver ou alterar seus envios</small>
                <small v-else>Envio encerrado — toque para ver</small>
            </span>
            <span class="gpx-cta-arrow">→</span>
        </router-link>

        <!-- Resultado oficial + certificado (só depois que o admin publica) -->
        <div v-if="resultState" class="result-cta">
            <span class="result-cta-icon">🏅</span>
            <span class="result-cta-text">
                <strong v-if="resultState === 'finished'">
                    {{ finishTime }}<template v-if="purshaseProduct.categoryPlacement != null"> · {{ purshaseProduct.categoryPlacement }}º na categoria</template><template v-if="purshaseProduct.overallPlacement != null"> · {{ purshaseProduct.overallPlacement }}º geral</template>
                </strong>
                <strong v-else>{{ resultState === 'dq' ? 'Desclassificado' : 'Não concluído' }}</strong>
                <small>Resultado oficial</small>
            </span>
            <button v-if="certificateEnabled && resultState === 'finished'"
                    type="button" class="result-cta-btn" :disabled="certBusy"
                    @click.stop.prevent="openCertificate">
                {{ certBusy ? 'Gerando…' : 'Ver / baixar certificado ↗' }}
            </button>
        </div>

    </div>

</template>

<script>
import _ from 'lodash'
import api from '@/api'
export default {
    data(){
        return {
            open:false,
            certBusy:false
            }
    },
    props:{
        purshaseProduct:{
            type:Object
        },
        index:{
            type:Number,
            default:0
        },
        gpxOpen:{
            type:Boolean,
            default:false
        },
        // null = ainda carregando a contagem; número = quantos tracklogs a
        // equipe já enviou.
        gpxCount:{
            default:null
        },
        // Flags do evento (vêm do pai, que carrega o evento uma vez por eventId).
        resultsPublished:{
            type:Boolean,
            default:false
        },
        certificateEnabled:{
            type:Boolean,
            default:false
        }
    },

    computed:{
        // Inscrição paga (por pagamento ou marcada pelo admin).
        isPaid:function(){
            return this.purshaseProduct.payed === true || this.purshaseProduct.payedByAdmin === true;
        },
        // Estado do bloco de envio. null = não renderiza (não paga, carregando,
        // ou janela fechada sem nenhum envio).
        gpxState:function(){
            if( !this.isPaid ) return null;
            if( this.gpxCount === null || this.gpxCount === undefined ) return null;
            if( this.gpxOpen ) return this.gpxCount > 0 ? 'sent-open' : 'send';
            return this.gpxCount > 0 ? 'sent-closed' : null;
        },
        // 'finished' | 'dnf' | 'dq' quando o resultado está publicado; null = não mostra.
        resultState:function(){
            if( !this.isPaid || !this.resultsPublished ) return null;
            return this.purshaseProduct.resultStatus || null;
        },
        finishTime:function(){
            const s = this.purshaseProduct.finishTimeSeconds;
            if( s == null || !isFinite(s) ) return '—';
            const t = Math.round(Number(s));
            const h = Math.floor(t/3600), m = Math.floor((t%3600)/60), ss = t%60;
            const p = (n)=> String(n).padStart(2,'0');
            return h+':'+p(m)+':'+p(ss);
        },
        product:function(){
            return this.purshaseProduct.product;
        },
        members:function(){
            return this.purshaseProduct.members;
        },
        team:function(){
            return this.purshaseProduct.team;
        },
        infoTeam:function(){
            let value = []
            let infos = _.get(this.purshaseProduct,'team.[0].infos');
            _.forOwn(infos, (v,k)=>{
                if( _.isString(v) && !_.isEmpty(v) ){
                    value.push(v);
                }
            })
            // Inscrição individual não tem equipe → mostra o nome do atleta.
            if( !value.length ){
                let athlete = _.get(this.purshaseProduct,'members.[0].infos.name');
                if( athlete ) value.push(athlete);
            }
            return value.join('/');

        },
        paymentStatus:function(){

            if(this.purshaseProduct.payed==true || this.purshaseProduct.payedByAdmin==true  ){
                return "payed";
            }else{
                return this.purshaseProduct.paymentStatus
            }
        },
        // needFill:function(){
        //     return this.purshaseProduct.teamDefinitions.needFillOnPurchase;
        // },
    },

    methods:{
        // Abre a aba no clique (antes do await) para não cair no bloqueador de pop-up.
        async openCertificate(){
            const w = window.open('', '_blank');
            if( w ) w.document.write('<p style="font-family:sans-serif;padding:2em;color:#555">Gerando certificado…</p>');
            this.certBusy = true;
            try{
                const r = await api.getJSONAsync('certificateGet', { purchaseProductId: this.purshaseProduct.id });
                if( !r || r.error || !r.html ) throw new Error((r && r.message) || 'Certificado indisponível.');
                if( !w ) throw new Error('O navegador bloqueou a nova aba. Permita pop-ups para este site.');
                w.document.open(); w.document.write(r.html); w.document.close();
            }catch(e){
                if( w ) w.close();
                alert(e.message || e);
            }finally{
                this.certBusy = false;
            }
        },
        removePurshaseProduct:function(){
            this.$store.commit('OrderStore/removePurchaseProduct',this.purshaseProduct)
        }
    }
}
</script>


<style lang="stylus" scoped >

.gpx-cta
    display: flex
    align-items: center
    gap: 0.7em
    margin: 0.8em
    padding: 0.85em 1.1em
    color: #fff
    text-decoration: none
    border-radius: 8px
    transition: filter 0.1s

    // laranja: falta enviar
    &.gpx-cta--send
        background: linear-gradient(135deg, #f5a623 0%, #f0820c 100%)
    // verde: enviado, janela aberta (pode alterar)
    &.gpx-cta--sent-open
        background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)
    // cinza: enviado, janela fechada (só ver)
    &.gpx-cta--sent-closed
        background: linear-gradient(135deg, #8a97a5 0%, #6b7a89 100%)

    &:hover
        filter: brightness(1.05)
        color: #fff

    .gpx-cta-icon
        font-size: 1.5em
        line-height: 1

    .gpx-cta-text
        display: flex
        flex-direction: column
        flex: 1

        strong
            font-size: 1em

        small
            opacity: 0.92
            font-size: 0.8em

    .gpx-cta-arrow
        font-size: 1.3em
        font-weight: 700

// Resultado publicado: dourado, mesmo tom do card de resultado da tela de detalhe.
.result-cta
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 0.7em
    margin: 0.8em
    padding: 0.85em 1.1em
    border-radius: 8px
    background: linear-gradient(135deg, #f6c343 0%, #e0a800 100%)
    color: #3d2f00

    .result-cta-icon
        font-size: 1.5em
        line-height: 1

    .result-cta-text
        display: flex
        flex-direction: column
        flex: 1
        min-width: 160px

        strong
            font-size: 1.05em

        small
            opacity: 0.85
            font-size: 0.8em

    .result-cta-btn
        padding: 0.55em 1em
        background: #3d2f00
        color: #fff
        border: none
        border-radius: 8px
        font-weight: 700
        cursor: pointer
        white-space: nowrap

        &:hover
            background: #241c00

        &:disabled
            opacity: 0.6
            cursor: default


.payment-status{
    position:absolute;
    right:10px;
    font-size:1.5em;
    &.payed{
        color:green;
    }
    &.waiting{
        color:yellow;
    }
    &.error{
        color:red;
    }
    &.canceled{
        color:red;
    }
}
// Card inteiro azul: o bloco de envio (laranja/verde/cinza) flutua sobre o
// azul, e a margem em volta dele mostra o azul do card — não branco.
.purshase-product-info{
    background var(--product-selector-bg-color);
    border-color var(--product-selector-bg-color);
}

.product-name{

    position:relative;
    background var(--product-selector-bg-color);

    .index{
        position:absolute;
        width larg = 25px;
        height: larg
        border-radius:25px 0 0 25px;
        left:-(larg);
        top:2px;
        background:var(--product-selector-color)
        line-height: larg;
        color:white;
        font-weight:bolder;
        text-align:center;
        font-size:9px;
        // opacity:0.6;
    }
    .name{
        color:white;
    }
    .delete{
        position:absolute;
        color:white;
        right:15px;
        top:15px;
        opacity:0.9;
        cursor:pointer;
    }    
}

</style>
